import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EntityDataServiceBase } from "@shared-base/entity-data-service.base";
import { UrlQueryDef } from '@shared-base/url-query-definition.base';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ServicePoliciesDataService extends EntityDataServiceBase
{
  constructor(protected http: HttpClient)
  {
    super(http, 'servicepolicies');
  }

  public getServicePolicies(language: string): Observable<any>
  {
    const queryDef = new UrlQueryDef();

    queryDef.params = {
      language
    };

    const subject = this.http.get(this.createUrl(''), queryDef.getRequestConfig());

    return subject;
  }
}

